import { render, staticRenderFns } from "./campusrosterManage.vue?vue&type=template&id=4b8cf676"
import script from "./campusrosterManage.vue?vue&type=script&lang=js"
export * from "./campusrosterManage.vue?vue&type=script&lang=js"
import style0 from "./campusrosterManage.vue?vue&type=style&index=0&id=4b8cf676&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports